// Shared tool catalog metadata for the frontend. The 6-bubble launcher and gating
// use this. `key` matches the entitlements tool_id; CRM + Settings are ungated.
import { useAuth } from './auth';

export interface ToolMeta {
  key: string;          // entitlement key ('' for ungated)
  label: string;
  desc: string;
  to: string;           // route
  gated: boolean;
  preview?: string;     // TilePreview scene key (Settings has none)
}

// The 6 home tiles, in order (brief Task 3).
export const HOME_TILES: ToolMeta[] = [
  { key: '', label: 'Contacts', desc: 'Your working list, with a timeline that fills itself.', to: '/contacts', gated: false, preview: 'crm' },
  { key: 'email', label: 'Email', desc: 'Tailored cold emails and reply handling.', to: '/tools/email', gated: true, preview: 'email' },
  { key: 'caller', label: 'Calls', desc: 'Phone prospecting that moves your pipeline.', to: '/tools/caller', gated: true, preview: 'caller' },
  { key: 'lead_finder', label: 'Lead Score', desc: 'Find and AI-score prospects.', to: '/tools/lead-finder', gated: true, preview: 'lead_finder' },
  { key: 'content', label: 'Content', desc: 'Brand voice + a 30-day calendar.', to: '/tools/content', gated: true, preview: 'content' },
  { key: '', label: 'Settings', desc: 'Targeting, team, compliance, preferences.', to: '/settings', gated: false },
];

/** Hook: does the current group own a tool? Ungated tools are always true. */
export function useEntitled(toolKey: string): boolean {
  const { me } = useAuth();
  if (!toolKey) return true;
  return !!me?.entitlements?.includes(toolKey);
}
